import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

/**
 * CRUD de contactos, anidado bajo /clients/:clienteId/contacts.
 * El backend valida que el contacto pertenezca al cliente (filtro
 * por clienteId en cada operaciÃ³n).
 */
export const fetchClientContacts = async (clienteId) => {
  const res = await apiFetch(
    `${API_BASE_URL}/clients/${clienteId}/contacts`,
    { headers: withTenant() },
  );
  return res.json();
};

export const createClientContact = async (clienteId, data) => {
  const res = await apiFetch(
    `${API_BASE_URL}/clients/${clienteId}/contacts`,
    {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(data),
    },
  );
  return res.json();
};

export const updateClientContact = async (clienteId, id, data) => {
  const res = await apiFetch(
    `${API_BASE_URL}/clients/${clienteId}/contacts/${id}`,
    {
      method: 'PUT',
      headers: JSON_HEADERS,
      body: JSON.stringify(data),
    },
  );
  return res.json();
};

export const deleteClientContact = async (clienteId, id) => {
  const res = await apiFetch(
    `${API_BASE_URL}/clients/${clienteId}/contacts/${id}`,
    { method: 'DELETE', headers: withTenant() },
  );
  return res.json();
};
